/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aria_Export_OptionsInputs */

const en_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export options`)
};

const de_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export-Optionen`)
};

const fr_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options export`)
};

const es_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de exportacion`)
};

const it_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di esportazione`)
};

const nl_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportopties`)
};

const pl_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcje eksportu`)
};

const fi_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vientiasetukset`)
};

const da_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksportmuligheder`)
};

const sv_aria_export_options = /** @type {(inputs: Aria_Export_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportalternativ`)
};

/**
* | output |
* | --- |
* | "Export options" |
*
* @param {Aria_Export_OptionsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const aria_export_options = /** @type {((inputs?: Aria_Export_OptionsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aria_Export_OptionsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_aria_export_options(inputs)
	if (locale === "fr") return fr_aria_export_options(inputs)
	if (locale === "es") return es_aria_export_options(inputs)
	if (locale === "it") return it_aria_export_options(inputs)
	if (locale === "nl") return nl_aria_export_options(inputs)
	if (locale === "pl") return pl_aria_export_options(inputs)
	if (locale === "fi") return fi_aria_export_options(inputs)
	if (locale === "da") return da_aria_export_options(inputs)
	if (locale === "sv") return sv_aria_export_options(inputs)
	return en_aria_export_options(inputs)
});